export const backend_large_projects = [
  {
    name: 'E-commerce API',
    image: '/images/e_commerce_api.jpg',
    url: 'https://e-commerce-api-200.herokuapp.com',
    git: 'https://github.com/joseokwu/natours',
  },
  {
    name: 'Jobs API',
    image: '/images/jobs_api.jpg',
    url: 'https://jobs-api-38.herokuapp.com/api-docs',
    git: 'https://github.com/joseokwu/natours',
  },
  {
    name: 'Task Manager',
    image: '/images/task_manager.jpg',
    git: 'https://github.com/joseokwu/task-manager-api',
  },
  {
    name: 'Store API',
    image: '/images/store_api.jpg',
    git: 'https://github.com/joseokwu/store-api',
  },
  {
    name: 'Json Web Token',
    image: '/images/json_web_token.jpg',
    git: 'https://github.com/joseokwu/json-web-token',
  },
  {
    name: 'File Upload',
    image: '/images/file_upload.jpg',
    git: 'https://github.com/joseokwu/file-upload',
  },
  {
    name: 'Send Email',
    image: '/images/send_email.jpg',
    git: 'https://github.com/joseokwu/send-email',
  },
  {
    name: 'Stripe Payment',
    image: '/images/stripe_payment.jpg',
    git: 'https://github.com/joseokwu/stripe-payment',
  },
];

export const backend_regular_projects = [
  {
    name: 'Task Manager',
    image: '/images/task_manager.jpg',
    url: 'https://github.com/joseokwu/task-manager-api',
  },
  {
    name: 'Store API',
    image: '/images/store_api.jpg',
    url: 'https://github.com/joseokwu/store-api',
  },
  {
    name: 'Json Web Token',
    image: '/images/json_web_token.jpg',
    url: 'https://github.com/joseokwu/json-web-token',
  },
  {
    name: 'File Upload',
    image: '/images/file_upload.jpg',
    url: 'https://github.com/joseokwu/file-upload',
  },
  {
    name: 'Send Email',
    image: '/images/send_email.jpg',
    url: 'https://github.com/joseokwu/send-email',
  },
  {
    name: 'Stripe Payment',
    image: '/images/stripe_payment.jpg',
    url: 'https://github.com/joseokwu/stripe-payment',
  },
];
